export const CREATE_CONTENT_DISCOVERY_CAMPAIGN =
  'CREATE_CONTENT_DISCOVERY_CAMPAIGN'
export const CREATE_CONTENT_DISCOVERY_CAMPAIGN_FULFILLED =
  'CREATE_CONTENT_DISCOVERY_CAMPAIGN_FULFILLED'
export const CREATE_CONTENT_DISCOVERY_CAMPAIGN_REJECTED =
  'CREATE_CONTENT_DISCOVERY_CAMPAIGN_REJECTED'
/**
 * Create a campaign from a content discovery item
 * @param {CreateContentDiscoveryCampaignPayload} payload
 * @returns {{payload: CreateContentDiscoveryCampaignPayload, type: string}}
 */
export const createContentDiscoveryCampaign = (payload) => ({
  type: CREATE_CONTENT_DISCOVERY_CAMPAIGN,
  payload,
})
